/** @jsx jsx */

import { jsx, Button } from "theme-ui"
import { useState, useEffect} from "react"

export const BackToTop = () => {
  const [show, setShow] = useState(false)
  const controlVisibility = () => {
    if (window.scrollY < 200) {
      setShow(false)
    } else {
      setShow(true)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", controlVisibility)
    return () => {
      window.removeEventListener("scroll", controlVisibility)
    }
  })
  return (
    <Button
      sx={{
        color: "gray",
        background: "transparent",
        borderStyle: "solid",
        borderRadius: 1,
        borderColor: "gray",
        borderWidth: "2px",
        p: 2,
        position: "fixed",
        bottom: 20,
        right: 20,
        cursor: "pointer",
        display: show ? ["none", "none", "inherit"] : "none"
      }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <b>^</b> <br /> TOP
    </Button>
  )
}
